import client from '../../client'

export default {
    FirstDisplay: param => {
      return new Promise((resolve, reject) => {
    
          var url = '/api/CommonInputReserveInfo/CommonInputReserveInfoFirstDisplay'
    
          var qs = require('qs')
          var data = qs.stringify({
            ircd: param.ircd,
            jgcd: param.jgcd,
            nend: param.nend,
            kscd: param.kscd,
            trsq: param.trsq
          })
    
          var config = {
            method: 'post',
            url: url,
            data: data
          }
    
          client(config)
            .then(responce => {
              // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
              resolve({
                responce: responce
              })
            })
            .catch(err => {
              console.log(err)
              reject()
            })
    
      })
    },
    Check: param => {
      return new Promise((resolve, reject) => {
    
          var url = '/api/CommonInputReserveInfo/CommonInputReserveInfoCheck'
    
          var qs = require('qs')
          var data = qs.stringify({
            ircd: param.ircd,
            jgcd: param.jgcd,
            nend: param.nend,
            reserveDate: param.reserveDate,
            jgnm: param.jgnm,
            jgnmIsErrorCheck: param.jgnmIsErrorCheck,
            hksh: param.hksh,
            hkshIsErrorCheck: param.hkshIsErrorCheck,
            hkkg: param.hkkg,
            hkkgIsErrorCheck: param.hkkgIsErrorCheck,
            hkno: param.hkno,
            hknoIsErrorCheck: param.hknoIsErrorCheck,
            hfkb: param.hfkb,
            hfkbIsErrorCheck: param.hfkbIsErrorCheck,
            cmnm: param.cmnm,
            cmnmIsErrorCheck: param.cmnmIsErrorCheck,
            nam1: param.nam1,
            nam1IsErrorCheck: param.nam1IsErrorCheck,
            nam2: param.nam2,
            nam2IsErrorCheck: param.nam2IsErrorCheck,
            ryk1: param.ryk1,
            ryk1IsErrorCheck: param.ryk1IsErrorCheck,
            ryk2: param.ryk2,
            ryk2IsErrorCheck: param.ryk2IsErrorCheck,
            btdyYear: param.btdyYear,
            btdyYearIsInput: param.btdyYearIsInput,
            btdyYearIsErrorCheck: param.btdyYearIsErrorCheck,
            btdyMonth: param.btdyMonth,
            btdyMonthIsInput: param.btdyYearIsInput,
            btdyMonthIsErrorCheck: param.btdyMonthIsErrorCheck,
            btdyDate: param.btdyDate,
            btdyDateIsInput: param.btdyYearIsInput,
            btdyDateIsErrorCheck: param.btdyDateIsErrorCheck,
            sex: param.sex,
            sexIsErrorCheck: param.sexIsErrorCheck,
            zip1: param.zip1,
            zip1IsErrorCheck: param.zip1IsErrorCheck,
            zip2: param.zip2,
            zip2IsErrorCheck: param.zip2IsErrorCheck,
            adr1: param.adr1,
            adr1IsErrorCheck: param.adr1IsErrorCheck,
            adr2: param.adr2,
            adr2IsErrorCheck: param.adr2IsErrorCheck,
            adr3: param.adr3,
            adr3IsErrorCheck: param.adr3IsErrorCheck,
            tel1: param.tel1,
            tel1IsErrorCheck: param.tel1IsErrorCheck,
            syno: param.syno,
            synoIsErrorCheck: param.synoIsErrorCheck,
            email1: param.email1,
            email1IsErrorCheck: param.email1IsErrorCheck,
            email2: param.email2,
            email2IsErrorCheck: param.email2IsErrorCheck,
            dmkb: param.dmkb,
            dmkbIsErrorCheck: param.dmkbIsErrorCheck,
            mem1: param.mem1,
            mem1IsErrorCheck: param.mem1IsErrorCheck
          })
    
          var config = {
            method: 'post',
            url: url,
            data: data
          }
    
          client(config)
            .then(responce => {
              // WebApiからのレスポンスをそのまま戻り値（プロミス）で返す
              resolve({
                responce: responce
              })
            })
            .catch(err => {
              console.log(err)
              reject()
            })
      })
    },
}



// WEBPACK FOOTER //
// ./src/api/Common/InputReserveInfo/CommonInputReserveInfoApi.js